import { API_ROOT } from '@/api/config'
import Http from '@/classes/http/Http'

export default {
  getFiles (caseId) {
    return Http.get({
      url: `cases/${caseId}/files`
    })
  },
  deleteFile (url) {
    return Http._delete({
      base_url: API_ROOT,
      url: url
    })
  }
}
